import $ from 'jquery';
import dt from 'datatables.net-dt';
import 'jquery-ui/datepicker';
import 'jquery-ui/sortable';
import 'datatables.net-responsive';
import 'datatables.net-colreorder';
// import './ColReorderWithResize';
import 'datatables.net-scroller';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-fixedcolumns-dt';
import { isSessionStorageAvailable, escapeRegExp, removeEscapeChars, triggerCustomEvent } from './utilities';
import {standardAjaxPost, standardAjaxGet} from "stdjs/standard-ajax";
import {displayMessages } from 'stdjs/validation';
import Translator from "./translate-service";
import _ from 'underscore';
import { initDataTableResizerFunction } from "stdjs/tablesResizing";
import { initDatePicker } from 'stdjs/forms';

import "stdjs/scrollResize-fudge"; // TODO - sort this out (Aaron gave up for a bit)

var datatablesStandardDom = "rt<'bottomLeft'i><'bottomRight'p><'clear'>";

var sessionStorageAvailable = isSessionStorageAvailable(); 

export function defineTable(tableSelector, columns, pageSize, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, storageLocation, responsive = true, colReorder = true, csvButton = false, fixedColumns = 0, scrollOnPaginate = true, scrollResize = true) {

    if (pageSize === 0) {
        return defineTableFull(tableSelector, columns, false, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, "irt<'bottomLeft'Bl><'bottomRight'p><'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    } else {
        return defineTableFull(tableSelector, columns, true, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, "irt<'bottomLeft'Bl><'bottomRight'p><'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    }
    
}

export function defineTableChild(tableSelector, columns, pageSize, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, storageLocation, responsive = true, colReorder = true, csvButton = false, fixedColumns = 0, scrollOnPaginate = true, scrollResize = true) {

    if (pageSize === 0) {
        return defineTableFull(tableSelector, columns, false, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave,  "rt<'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    } else {
        return defineTableFull(tableSelector, columns, true, pageSize, true, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, "rt<'clear'>", storageLocation, responsive, colReorder, csvButton, fixedColumns, scrollOnPaginate, scrollResize);
    }
    
}

export function defineTableStatic(tableSelector, colDefs, zeroRecords, responsive = true) {

    return defineTableFull(tableSelector, false, 9999, false, [], [], colDefs, zeroRecords, false, [], [], [], [], "rt<'clear'>", responsive);
    
}

function defineTableFull(tableSelector, columns, paging, pageSize, ordering, defaultSort, fixedSort, colDefs, zeroRecords, stateSave, dom, storageLocation, responsive = true, colReorder = true, csvButton = false, fixedColumns = 0, scrollOnPaginate = true, scrollResize = true) {
 
    $.fn.dataTable.ext.classes.sPageButton = 'btn stdButton m-2 tablePageButton';

    var scrollTableSelector = tableSelector + "_wrapper";

    /**
     * Create the table filters before columns are hidden
     * and indexes become mismatched. This is the only time
     * we can guarantee that all the columns will be visible
     */
    $(tableSelector + " thead tr.search th").each(function(i, el){
        $(el).attr("data-colIdx", i);
        $(el).attr("data-colName", columns[i].name);
        
        switch (columns[i].searchType) {
            case "*INPUT":
                inputFilter(tableSelector, columns, i);
                break;
            case "*CHECKBOX":
                checkboxFilter(tableSelector, columns, i);
                break;
            case "*DATE":
                dateFilter(tableSelector, columns, i);
                break;
            case "*SELECT":
                selectFilter(tableSelector, columns, i);
                break;
            case "*SELECTBOOL":
                selectFilter(tableSelector, columns, i, "*SELECTBOOL");
                break;
            
            case null:
                if(columns[i].name == "actions"){
                    actionsIcon(tableSelector, i);
                }
                break;
        
            default:
                break;
        }
    });

    var buttonsVal = [];

    if(csvButton){
        var buttonsVal = [{
            extend: 'csv',
            text: Translator.tr("CSV Export"),
            exportOptions: {
                modifier: {
                    search: 'none'
                },
                orthogonal: "filter",
                customizeData: function(data){
                    
                    /**
                     * All this is to make sure invisible columns are put to the end of the csv
                     */
                    var visData = {
                        header: [],
                        footer: null,
                        body: []
                    };

                    var invisData = {
                        header: [],
                        footer: null,
                        body: []
                    };

                    $.each(data.header, function(index, value){
                        $.each(table.columns().header(), function(i, v){
                            if(v.innerText == value){
                                if(table.column(i).visible()){
                                    visData.header.push(data.header[index]);

                                    $.each(data.body, function(idx, val){
                                        if(typeof visData.body[idx] == "undefined"){
                                            visData.body[idx] = [];
                                        }
                                        visData.body[idx].push(val[index]);
                                    });
                                } else {
                                    invisData.header.push(data.header[index]);

                                    $.each(data.body, function(idx, val){
                                        if(typeof invisData.body[idx] == "undefined"){
                                            invisData.body[idx] = [];
                                        }
                                        invisData.body[idx].push(val[index]);
                                    });
                                }
                            }
                        });
                    });

                    var ordered = {
                        header: [],
                        footer: null,
                        body: []
                    };

                    ordered.header = ordered.header.concat(visData.header);
                    ordered.body = ordered.body.concat(visData.body);
                    ordered.header = ordered.header.concat(invisData.header);

                    $.each(invisData.body, function(i, v){
                        ordered.body[i] = ordered.body[i].concat(v);
                    });

                    data.body = ordered.body;
                    data.header = ordered.header;
                }
            }
        }];
    }

    var table = $(tableSelector).DataTable({
        autoWidth: false,
        responsive: responsive,
        columnDefs: colDefs,
        order: defaultSort,
        orderFixed: fixedSort,
        orderCellsTop: true,
        processing: false,
        paging: paging,
        ordering: ordering,
        pagingType: "full_numbers",
        lengthMenu: [25, 50, 100],
        pageLength: pageSize,
        dom: dom,
        info: false,

        data: [],
        columns: columns,
        deferRender: true,

        colReorder: colReorder,
        scrollY: false,
        scrollX: ! responsive,
        scrollResize: scrollResize,
        scrollCollapse: true,
        buttons: buttonsVal,

        fixedColumns: responsive ? null : {leftColumns: fixedColumns},

        language: {
            lengthMenu: " " + Translator.tr("_MENU_ records per page"),
            zeroRecords: Translator.tr(zeroRecords),
            infoEmpty: Translator.tr("No records available"),
            infoFiltered: "( " + Translator.tr("_MAX_ total records") + " )",
            paginate: {
                first: Translator.tr("First"),
                last: Translator.tr("Last"),
                previous: Translator.tr("Previous"),
                next: Translator.tr("Next")
            }
        },
        stateSave: stateSave,
        stateDuration: -1,
        stateLoadCallback: function (settings, data) {
            if (sessionStorageAvailable) {
                var state = JSON.parse(sessionStorage.getItem(storageLocation));
                /**
                 * Setting up the filters earlier won't have been able to 
                 * get the previous state as the table won't have been initialised
                 * Do it here instead
                 */
                if (state){

                    /**
                     * Use this as a basic reset for when the columns in
                     * the backend change.
                     * If we have a different number of columns or
                     * we can't find a match for each column, delete the
                     * stored state.
                     */
                    var resetFilters = false;
                    if (columns.length !== state.columns.length) {
                        resetFilters = true;
                    } else {
                        resetFilters = !columns.reduce((acc, col) => {
                            return acc && state.columns.find( el => el.name === col.name) !== undefined;
                        }, true);
                    }

                    if (resetFilters) {
                        sessionStorage.removeItem(storageLocation);
                        return false;
                    }

                    $(tableSelector + " thead tr.search th").each(function (i, el) {

                        /**
                         * The column index can change if new columns are added
                         * or columns are removed etc, so we can't go by column index.
                         * Instead, match columns to state using the column name.
                         */
                        var colName = $(el).attr("data-colName");
                        var colIdx = $(el).attr("data-colIdx");
                        if (colName === undefined || colIdx === undefined) {
                            return;
                        }

                        /**
                         * To optimise, check if the indexes match so we don't have to filter through
                         * each array
                         */
                        var col;
                        var stateCol;
                        if (colIdx < columns.length && colIdx < state.columns.length && columns[colIdx].name != undefined && columns[colIdx].name === state.columns[colIdx].name) {
                            col = columns[colIdx];
                            stateCol = state.columns[colIdx];
                        } else {
                            col = columns.filter((col) => col.name != undefined && col.name === colName);
                            if (col.length === 0){
                                return;
                            }
                            col = col[0];
    
                            stateCol = state.columns.filter((col) => col.name != undefined && col.name === colName);
                            if (stateCol.length === 0){
                                return;
                            }
                            stateCol = stateCol[0];
                        }


                        var searchType;
                        var searchVal;
                        try {
                            searchType = col.searchType;
                            searchVal = stateCol.search.search;
                        } catch (e) {
                            return;
                        }
                        
                        switch (searchType) {
                            case "*INPUT":
                                var input = $("input", el);
                                input.val(searchVal);
                                break;
                            case "*CHECKBOX":
                                var input = $("input", el);
                                if (searchVal === "1") {
                                    input.prop("checked", true);
                                }
                                break;
                            case "*DATE":
                                var input = $("input", el);
                                try {
                                    input[0]._flatpickr.setDate(searchVal);
                                } catch (e) {
                                    console.error(e);
                                }
                                break;
                            case "*SELECT":
                                // This is prefilled when we update the selects anyway
                                break;
    
                            default:
                                break;
                        }
    
                    });
                }
                return state || false;
            }
        },
        stateSaveCallback: function (settings, data) {
            if (sessionStorageAvailable) {
                // Save the col name with the search data etc.
                data.columns = data.columns.map((col, colIdx) => {
                    var searchCell = $("tr.search th:eq(" + colIdx + ")", tableSelector);
                    col.name = searchCell.attr("data-colName");
                    return col;
                });
                sessionStorage.setItem(storageLocation, JSON.stringify(data));
            }
        },
        initComplete: function(settings, json) {
            $(scrollTableSelector).append(`
                <div class="dataLoadingCover tableDataLoadingCover" style="display: none;">
                    <img src="/images/ajax-loader.gif" alt="">
                </div>
            `);
            $(tableSelector).show();
        },
        rowCallback: function( row, data, displayNum, displayIndex, dataIndex ){
            if ( typeof data["DT_X_Class"] !== "undefined" ){
                $( row ).addClass( data[ "DT_X_Class" ] );
            }
        },
        drawCallback: function(settings) {

            $.each($(".dataTables_scrollBody thead tr:not(.search) th.sizeToContent", scrollTableSelector), function(i, v){
                $(v).css("width", "1%");
            });

            var widths = [];

            $.each($(".dataTables_scrollBody thead tr:not(.search) th", scrollTableSelector), function(i, v){
                widths[i] = $(v).css("width");
            });

            $.each($(".dataTables_scrollHead thead tr:not(.search) th", scrollTableSelector), function(i, v){
                $(v).width(widths[i]);
            });
        }
    });
    // new $.fn.dataTable.ColReorder(table);
    // createSearchRow(table); not needed now thead in html again

    if (responsive){


        responsiveResize(table, scrollTableSelector, columns);
        table.on("responsive-resize", function(){
            responsiveResize(table, scrollTableSelector, columns);
        });
    }

    if (scrollOnPaginate){
        table.on('page.dt', function() {
            $('html, body').animate({
              scrollTop: $(tableSelector + "_wrapper").offset().top
            });
        });
    }

    // TODO if you edit the name of one of the fixed columns it plays havoc with the table resizing.
    if(fixedColumns > 0){

        $("table.DTFC_Cloned tr.search th input", scrollTableSelector).each(function(i, v){
            var colIdx = $(v).closest("th").data("colidx");
            var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
            if (isDataTable){
                var state = $(tableSelector).DataTable().state();
                if (state !== null) {
                    $(v).val(state.columns[colIdx].search.search);
                }
            }
        });

        $(scrollTableSelector).on("keyup", "table.DTFC_Cloned tr.search th input", function(e){

            var colIdx = $(this).closest("th").data("colidx");
            var cursorStart = $(this)[0].selectionStart;
            // var cursorEnd = $(this)[0].selectionEnd;

            $(".dataTables_scrollHead tr.search th[data-colidx='" + colIdx + "'] input", scrollTableSelector).val($(this).val());
            $(".dataTables_scrollHead tr.search th[data-colidx='" + colIdx + "'] input", scrollTableSelector).trigger("keyup");
            $("table.DTFC_Cloned tr.search th[data-colidx='" + colIdx + "'] input").focus();
            $("table.DTFC_Cloned tr.search th[data-colidx='" + colIdx + "'] input")[0].selectionStart = cursorStart;
            $("table.DTFC_Cloned tr.search th[data-colidx='" + colIdx + "'] input")[0].selectionEnd = cursorStart;
        });

    }

    $(window).resize(function(){
        table.columns.adjust().draw();
    });

    if(colReorder){
        table.colReorder.disable();
    }

    var state = $(tableSelector).DataTable().state();
    if (state !== null) {
        if(colReorder){
            table.colReorder.reset();
        }
    }

    return table;
}

export function getTableWrapper( tableId ){
    return $( "#" + tableId + "_wrapper" );
}

export function showSearchRow( tableId ){
    var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
    searchRow.show();
}

export function hideSearchRow( tableId ){
    var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
    searchRow.hide();
}

function createSearchRow(table){
    var header = $(table.table().header());
    var searchRow = $("<tr class='search' />").appendTo(header);
    $.each(header.get(0).rows[0].cells, function(index, value){
        $("<th />").appendTo(searchRow);
    });
}

function selectFilter(tableSelector, columns, colIdx, type = '*SELECT') {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === ""){
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);

        var selectClass = '';
        switch(type) {
            case '*SELECT': selectClass = 'dtSelectFilter'; break;
            case '*SELECTBOOL': selectClass = 'dtSelectBoolFilter'; break;
        }

        var select = $('<select class="' + selectClass + '" />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("change", function () {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable){
                    var value = $(this).val();
                    if (value.length > 0) {
                        value = "^" + escapeRegExp(value) + "$";
                    }
                    $(tableSelector).DataTable()
                        .column(columns[colIdx].name + ":name")
                        .search(value, true, false, false)
                        .draw();
                }
            });

            select.append($("<option value=\"\">&nbsp;</option>"));

            var filterValues = [""];
            
            if (isDataTable){
                var apiObject = $(tableSelector).DataTable();

                apiObject
                    .column(colIdx)
                    .cache("search")
                    .sort()
                    .unique()
                    .each( function (d) {
                        filterValues.push(d);
                        if (d !== "") {
                            select.append($("<option value=\"" + d + "\">" + d + "</option>"));
                        }
                    });
    
                var state = apiObject.state();
                if(state !== null){
                    var stateValue = state.columns[colIdx].search.search;
                    if ($.inArray(stateValue, filterValues) === -1){
                        select.append($("<option value=\"" + stateValue + "\">" + stateValue + "</option>"));
                    }
                    select.val(stateValue);
                }
            }
    }
}

function inputFilter(tableSelector, columns, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === ""){
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
        var input = $('<input type="text" />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("keyup", function () {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable){
                    $(tableSelector).DataTable()
                        .column(columns[colIdx].name + ":name")
                        .search($(this).val(), false, false, true)
                        .draw();
                }
            });
    
        if (isDataTable){
            var state = $(tableSelector).DataTable().state();
            if (state !== null) {
                input.val(state.columns[colIdx].search.search);
            }
        }
    }
}

function checkboxFilter(tableSelector, columns, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === "") {
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
        var input = $('<input type="checkbox" />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("click", function () {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable) {
                    if ($(this).is(":checked")) {
                        $(tableSelector).DataTable()
                            .column(columns[colIdx].name + ":name")
                            .search("1", false, false, true)
                            .draw();
                    } else {
                        $(tableSelector).DataTable()
                            .column(columns[colIdx].name + ":name")
                            .search("", false, false, true)
                            .draw();
                    }
                }
            });

        if (isDataTable) {
            var state = $(tableSelector).DataTable().state();
            if (state !== null) {
                if ($(tableSelector).DataTable().state().columns[colIdx].search.search === "1") {
                    input.prop("checked", true);
                }
            }
        }
    }
}

function dateFilter(tableSelector, columns, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === "") {
        var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
        var input = $('<input data-text="test" type="text" />')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            )
            .on("keyup", function (e) {
                if (e.keyCode === 8 || e.keyCode === 46) {
                    datepicker.clear();
                    datepicker.close();
                }
            });

        var datepicker = initDatePicker( $(input), userDateFormat, {
            dateFormat: "d/m/Y",
            onChange: function (selectedDates, dateText, inst) {
                var isDataTable = $.fn.DataTable.isDataTable(tableSelector);
                if (isDataTable){
                    $(tableSelector).DataTable()
                        .column(columns[colIdx].name + ":name")
                        .search(dateText, false, false, true)
                        .draw();
                }
            }
        });
        

        if (isDataTable){
            var state = $(tableSelector).DataTable().state();
            if (state !== null && state.columns[colIdx].visible) {
                datepicker.setDate(state.columns[colIdx].search.search);
            }
        }
    }
}

function actionsIcon(tableSelector, colIdx) {
    var searchCell = $(tableSelector + " tr.search th:eq(" + colIdx + ")");
    if (searchCell.html() === ""){
        var icon = $('<span class="icomoon">' + icons["search"] + '</span>')
            .appendTo(
                $(tableSelector + " tr.search th:eq(" + colIdx + ")")
            );
    }
}

function removeFilters(apiObject, domObject) {

    apiObject.columns().flatten().each(function(colIdx) {

        if ($("tr.search th:eq(" + colIdx + ") input, tr.search th:eq(" + colIdx + ") select", domObject).length){
            $("tr.search th:eq(" + colIdx + ")", domObject).html("");
        }
        
    });
    
}

export function checkClickedRow(jTarget, clickedRow) {
    return !clickedRow.hasClass("child") 
            && !jTarget.hasClass("dataTables_empty") 
            && (jTarget.hasClass("controlColumnContent") 
                    || jTarget.is("img.profile-circle") 
                    || (jTarget.is("td") && !jTarget.hasClass("controlColumn"))
                );
}

function responsiveResize(table, scrollTableSelector, columns){
    table.columns().flatten().each(function(colIdx){
        if(table.columns().responsiveHidden()[colIdx]){
            $(".dataTables_scrollHead table thead tr.search th:eq(" + colIdx + ")", scrollTableSelector).show();
        } else {
            $(".dataTables_scrollHead table thead tr.search th:eq(" + colIdx + ")", scrollTableSelector).hide();
        }
    });

    // removeFilters(table, tableSelector);
    // selectFilters(table, tableSelector, columns);
    // inputFilters(table, tableSelector, columns);
    // checkboxFilters(table, tableSelector, columns);
    // datepickerFilters(table, tableSelector, columns);            

}

function getResponsiveVisibleCols(table){
    var count = 0;
    table.columns().responsiveHidden().flatten().each(function(colIdx){
        if (colIdx) {
            count++;
        }
    });
    return count;
}

export function updateSelectFilters(apiObject, domObject) {
    apiObject.columns().flatten().each(function (colIdx) {

        /**
         * Update every standard Select Filter
         */
        var select = $(`tr.search th[data-colIdx=\"${colIdx}\"] select.dtSelectFilter`, domObject);
        if ( select.length > 0 ) {

            select.empty();

            select.append($("<option value=\"\">&nbsp;</option>"));

            var filterValues = [""];

            apiObject
                .column(colIdx)
                .cache("search")
                .sort()
                .unique()
                .each(function (d) {
                    filterValues.push(d);
                    if (d !== "") {
                        select.append($("<option value=\"" + _.escape(d) + "\">" + _.escape(d) + "</option>"));
                    }
                });

            var state = apiObject.state();
            if (state !== null) {
                select = addStateValue(state, select, filterValues)
            }

        }

        /**
         * Update every bool (switch/bool) Select Input
         */
        var selectBool = $(`tr.search th[data-colIdx=\"${colIdx}\"] select.dtSelectBoolFilter`, domObject);
        if ( selectBool.length > 0) {

            selectBool.empty();

            selectBool.append($("<option value=\"\">&nbsp;</option>"));

            var filterValues = ["1", "0"];

            selectBool.append($("<option value=\"" + '1' + "\">" + 'Yes' + "</option>"));
            selectBool.append($("<option value=\"" + '0' + "\">" + 'No' + "</option>"));


        }

        function addStateValue(state, select, filterValues) {
            var stateValue = state.columns[colIdx].search.search;
            if (stateValue.length > 0) {
                if (stateValue[0] === "^") {
                    stateValue = stateValue.slice(1);
                }
            }
            if (stateValue.length > 0) {
                if (stateValue[stateValue.length - 1] === "$") {
                    stateValue = stateValue.slice(0, -1);
                }
            }
            stateValue = removeEscapeChars(stateValue);
            if ($.inArray(stateValue, filterValues) === -1) {
                select.append($("<option value=\"" + stateValue + "\">" + stateValue + "</option>"));
            }
            select.val(stateValue);

            return select;
        }

    });
}

export function updateChildColumnConfigs(tableReference, columnSourceData = {}, successCallback){

    if (typeof successCallback === "undefined" || typeof successCallback !== "function"){
        successCallback = null;
    }
    
    var data = {
        table: tableReference,
        columnInfo: columnSourceData              
    };

    standardAjaxPost(updateUserColumnConfigUrl, data, successCallback, null, false);
}

export function updateColumnConfigs(table, tableReference, successCallback, columnSourceData = {}){
    if (typeof successCallback === "undefined" || typeof successCallback !== "function"){
        successCallback = null;
    }
    
    var colInfo = getColumnInfo(table);

    var data = $.extend( {}, columnSourceData, {
        table: tableReference,
        columnInfo: colInfo              
    });

    standardAjaxPost(updateUserColumnConfigUrl, data, successCallback, null, false);
}

export function getColumnInfo(table){

    var columns = table.settings().init().columns;

    var colInfo = {};

    for(var i=0; i<columns.length; i++){
        var colName = columns[i].name;
        var order = table.column(colName + ":name").flatten()[0];
        var visible = table.column(colName + ":name").visible();
        var name = $(table.column(colName + ":name").header()).text();

        var data = {
            name: name,
            order: order,
            visible: visible ? 1 : 0
        };

        colInfo[colName] = data;
    }

    return colInfo;

}

export function clearTableData( table ){
    table.clear();
}

export function updateTableData(table, data){
    insertTableDataCore( table, data, "*CREATE" );
}

export function appendTableData( table, data ){
    return insertTableDataCore( table, data, "*UPDATE" );
}

export function replaceTableData( table, data ){
    insertTableDataCore( table, data, "*REPLACE" );
}

function insertTableDataCore(table, data, mode ){
    /**
     * To reduce the size of the response
     * default the sort/filter value to the
     * display value if sort/filter are null
     */
    data.map(function(row){
        Object.keys(row).forEach(function(colName){
            if (colName !== "DT_RowId"  &&  colName.substring(0, 5) !== "DT_X_" 
                && colName !== "DT_RowAttr"
            ){
                if (!row[colName].hasOwnProperty('sort') || row[colName].sort === null){
                    row[colName].sort = row[colName].display;
                }
                if (!row[colName].hasOwnProperty('filter') || row[colName].filter === null){
                    row[colName].filter = row[colName].display;
                }
            }
        });
        return row;
    });
    
    var tableWrapperId = "#" + $(table.table().container()).attr("id");
    
    if ( mode === "*CREATE" ){
        table.clear();
    }    
    
    if ( mode === "*REPLACE" ){
        $.each( data, function( index, row){            
            table.row( "#" + row.DT_RowId ).remove();
        });        
    }
    
    table.rows.add(data).draw();
    updateSelectFilters(table, tableWrapperId);
    table.columns.adjust().draw();
    
    if ( mode === "*CREATE" ){
        // TODO scope this by table
        $(".tableDataLoadingCover").fadeOut();
    }
    
    var rowids = [];
    $.each( data, function( index, row){
        rowids.push(row.DT_RowId);
    });
    return rowids;
}

export function showHideChildRow(table, row, url, data = {}, dataKey = "result"){

    if(data.loaderId !== undefined) {
        $(data.loaderId).show();
    }
    
    var modifiedSuccessCallback = function(data){
        
        if (row.child.isShown()) {        
            row.child.hide();
        } else {        
            row.child(data.tabHtml).show();
            var childRow = row.child();

            if (childRow !== undefined){
                childRow.children().addClass("childRow");                
                var containerWidth = childRow.closest("table").width();                
                childRow.find(".standardResizableSection-container").attr("data-width", containerWidth);
            }
        }

        if(data.loaderId !== undefined) {
            $(data.loaderId).hide();
        }

        table.draw();
    }

    var modifiedErrorCallback = function(data) {
        if(data.loaderId !== undefined) {
            $(data.loaderId).hide();
        }
    }

    standardAjaxPost(url, data, modifiedSuccessCallback, modifiedErrorCallback, false);
    
}

export function updateTableDataFromUrl(table, url, data = {}, dataKey = "result", successCallback = function(data){}, errorCallback = function(data){}){
    var modifiedSuccessCallback = function(data){
        if(data.success){
            var responseData = data[dataKey];
            if (responseData == null){
                $(".tableDataLoadingCover").fadeOut();
                errorCallback(data);
                return;
            }
            
            if (typeof data[dataKey] === "string"){
                try {
                    responseData = JSON.parse(responseData);
                } catch (error) {
                    console.error(error);
                    $(".tableDataLoadingCover").fadeOut();
                    errorCallback(data);
                    return;
                }
            }

            updateTableData(table, responseData);
            successCallback(data);
        } else {
            $(".tableDataLoadingCover").fadeOut();
        }
    }

    var modifiedErrorCallback = function(data) {
        $(".tableDataLoadingCover").fadeOut();
        displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
        errorCallback(data);
    }

    $(".tableDataLoadingCover").fadeIn();
    standardAjaxPost(url, data, modifiedSuccessCallback, modifiedErrorCallback, false);
}

export function setColumnVisibility(table, isChildMode, tableReference, colName, visible, columnSourceData = {}, dropdownContainer){

    if (isChildMode){

        /**
         * Get all the instances of the table using the table reference
         */
        var tables = $(".dataTables_scrollBody table[data-table-ref='" + tableReference + "']");
        if (tables.length > 0){

            var tableToExctract;

            /**
             * Loop through each table and clear any search inputs and hide/show the relevant columns
             */
            tables.each(function(){

                var table = $(this);
                var dtTable = $(this).DataTable();
                var column = dtTable.column(colName + ":name");

                if(table.parent().hasClass("dataTables_scrollHeadInner")){
                    return;
                }

                if (!visible){
                    var inputs = table.find(`thead tr.search th[data-colIdx=\"${column.index()}\"] input, thead tr.search th[data-colIdx=\"${column.index()}\"] select`, tableWrapperId);                    
                    inputs.each(function(i, el){
                        $(el).val("");
                    });    
                    column.search("", false, false, true);
                }

                column.visible(visible);
                dtTable.draw();

                if (tableToExctract === undefined){
                    tableToExctract = dtTable;
                }
            });

            updateColumnConfigs(tableToExctract, tableReference, null, {});
            
        } else {
            updateChildColumnConfigs(tableReference, buildColDataFromSortable(dropdownContainer));
        }

        return;

    } else {

        var tableWrapperId = "#" + $(table.table().container()).attr("id");
        var column = table.column(colName + ":name");    

        /**
         * If we're hiding a column, remove any filters
         * and empty the input
         */
        if (!visible){
            var inputs = $(`thead tr.search th[data-colIdx=\"${column.index()}\"] input, thead tr.search th[data-colIdx=\"${column.index()}\"] select`, tableWrapperId);
            inputs.each(function(i, el){
                $(el).val("");
            });    
            column.search("", false, false, true);
        }

        column.visible(visible);
        table.draw();
        triggerCustomEvent( table.nodes()[0], "merisis-post-column-visibility" );

        updateColumnConfigs(table, tableReference, null, columnSourceData);
    }
}

/**
 * EDIT COLUMNS
 */
export function setupEditColumnsEventsForChild(id, currentTableReference = null, columnSourceData = {}){

    var selectColumnsDropdownId = (id == null) ? "#selectColumnsDropdown" : id;

    if(currentTableReference === null) {
        currentTableReference = tableReference;
    }
    
    var childTableColumnsJson = JSON.parse(columnSourceData);    
    var dropdown = $(selectColumnsDropdownId + " .columnGroup[data-table-ref='" + currentTableReference + "']");            

    childTableColumnsJson.forEach(function(col, idx){                                                    
        var line = dropdown.find(".columnSelectLine[data-col-name='" + col.name  + "']");
        setCheckbox(line.find(".switchContainer"), col.visible);
    });

    dropdown.find(".columnSelectLine .switchContainer").click(function(e){
        e.stopPropagation();
        var colVis = toggleCheckbox($(this));        
        setColumnVisibility(null, true, currentTableReference, $(this).find("input").data("col-name"), colVis, columnSourceData, dropdown);        
    });

    dropdown.find(".columnName .editName").click(function(e){
        e.stopPropagation();
        var line = $(this).closest(".columnSelectLine");
        
        if($(this).hasClass("save")){
            saveColumnName(line, $(this).closest(".columnName").find("input"), columnSourceData );
        }

        line.find(".columnName").toggle();
        line.find(".columnName input").focus();
        line.find(".columnName input").select();
    });

    dropdown.find(".columnSelectLine .columnName input").keyup(function(e) {
        if (e.keyCode !== 13){
            return;
        }
        var line = $(this).closest(".columnSelectLine");
        saveColumnName(line, $(this), columnSourceData );
        line.find(".columnName").toggle();
    });

    dropdown.find(".columnSelectLine").click(function(e){
        e.stopPropagation();
        $(".switchContainer", $(this)).trigger("click");
    });

    dropdown.find("input, .dragIcon").click(function(e){
        e.stopPropagation();
    });

    function setCheckbox(switchContainer, value){
        var checkbox = switchContainer.find("input");
        checkbox.prop("checked", value);
        if (value){
            switchContainer.find(".checkmark").css("display", "block");
        } else { 
            switchContainer.find(".checkmark").css("display", "none");
        }
    }

    function toggleCheckbox(switchContainer){
        var checkbox = switchContainer.find("input");
        
        if(checkbox.prop("checked")){
            checkbox.prop("checked", false);
            switchContainer.find(".checkmark").css("display", "none");
        } else {
            checkbox.prop("checked", true);
            switchContainer.find(".checkmark").css("display", "block");
        }
        return checkbox.prop("checked");
    }

    function saveColumnName(line, input, columnSourceData = {}) {

        var colName = $(line).data("col-name");
        var text = input.val();
        if (text === ""){
            text = input.attr("data-default-to");
        }

        $(".columnName .text", line).text(text);
        input.attr("data-prev-value", text);

        /**
         * Get all the instances of the table using the table reference
         */
        var tables = $(".dataTables_scrollBody table[data-table-ref='" + currentTableReference + "']");
        if (tables.length > 0){

            var tableToExctract;

            /**
             * Loop through each table and clear any search inputs and hide/show the relevant columns
             */
            tables.each(function(){
                
                var table = $(this);
                var dtTable = $(this).DataTable();
                var column = dtTable.column(colName + ":name");

                if(table.parent().hasClass("dataTables_scrollHeadInner")){
                    return;
                }

                $(dtTable.column(colName + ":name").header()).html("<div>" + text + "</div>");

                if (tableToExctract === undefined){
                    tableToExctract = dtTable;
                }

            });

            updateColumnConfigs(tableToExctract, currentTableReference);

        } else {
            updateChildColumnConfigs(currentTableReference, buildColDataFromSortable(dropdown));
        }
        
        return;
    }
    
}


export function setupEditColumnsEvents(table, id, currentTableReference = null, fixedColumnSuccessCallback = null, columnSourceData = {}){
    var selectColumnsDropdownId = (id == null) ? "#selectColumnsDropdown" : id;

    if(currentTableReference === null) {
        currentTableReference = tableReference;
    }

    $.each($(selectColumnsDropdownId + " .switchContainer input"), function(index, value){
        var colName = $(value).data("col-name");
        if($(value).prop("checked") != table.column(colName + ":name").visible()){
            toggleCheckbox($(value).closest(".switchContainer"));
        }
    });

    $(selectColumnsDropdownId + " .columnSelectLine .switchContainer").click(function(e){
        e.stopPropagation();
        var colVis = toggleCheckbox($(this));
        //getMultiTableRef($(this).closest(".columnSelectLine"));
        setColumnVisibility(table, false, currentTableReference, $(this).find("input").data("col-name"), colVis, columnSourceData);
    });

    $(selectColumnsDropdownId + " .columnSelectLine").click(function(e){
        e.stopPropagation();
        $(".switchContainer", $(this)).trigger("click");
    });

    $("input, .dragIcon", selectColumnsDropdownId + " .columnSelectLine").click(function(e){
        e.stopPropagation();
    });

    $(selectColumnsDropdownId).on("hide.bs.dropdown", function(e){
        $.each($(".columnName", $(this)), function(index, value){
            if($(value).hasClass("edit")){
                var input = $(value).find("input");
                $(value).hide();
                input.val(input.attr("data-prev-value"));
            } else {
                $(value).show();
            }
        });
        $(".fixedColumns").show();
        $(".fixedColumns.edit").hide();
    });

    $(".columnName .editName", selectColumnsDropdownId).click(function(e){
        e.stopPropagation();
        var line = $(this).closest(".columnSelectLine");
        
        //getMultiTableRef(line);

        if($(this).hasClass("save")){
            saveColumnName(line, $(this).closest(".columnName").find("input"), columnSourceData );
        }

        line.find(".columnName").toggle();
        line.find(".columnName input").focus();
        line.find(".columnName input").select();
    });

    $(".columnSelectLine .columnName input", selectColumnsDropdownId).keyup(function(e) {
        if (e.keyCode !== 13){
            return;
        }
        var line = $(this).closest(".columnSelectLine");
        saveColumnName(line, $(this), columnSourceData );
        line.find(".columnName").toggle();
    });
    
    function saveColumnName(line, input, columnSourceData = {}) {

        var colName = $(line).data("col-name");
        var text = input.val();
        if (text === ""){
            text = input.attr("data-default-to");
        }

        $(table.column(colName + ":name").header()).html("<div>" + text + "</div>");
        $(".columnName .text", line).text(text);
        updateColumnConfigs(table, currentTableReference, fixedColumnSuccessCallback, columnSourceData );
        input.attr("data-prev-value", text);
    }

    function toggleCheckbox(switchContainer){
        var checkbox = switchContainer.find("input");
        
        if(checkbox.prop("checked")){
            checkbox.prop("checked", false);
            switchContainer.find(".checkmark").css("display", "none");
        } else {
            checkbox.prop("checked", true);
            switchContainer.find(".checkmark").css("display", "block");
        }
        return checkbox.prop("checked");
    }

    $(".fixedColumnsLine .editFixed", selectColumnsDropdownId).click(function(e){
        e.stopPropagation();
        var line = $(this).closest(".fixedColumnsLine");
        
        if($(this).hasClass("save")){
            saveFixedColumns(line.find("input"), currentTableReference, fixedColumnSuccessCallback);
        } else {
            var input = line.next(".fixedColumnsLine").find("input");
            manageEditColumnTranslation(input);
            input.focus();
            input.select();
        }
        $(".fixedColumnsLine").toggle();
    });

    $(".fixedColumnsLine input", selectColumnsDropdownId).keyup(function(e) {
        if (e.keyCode !== 13){
            return;
        }

        saveFixedColumns($(this), currentTableReference, fixedColumnSuccessCallback);
        $(".fixedColumnsLine").toggle();
    });

    $(document).on("change", ".fixedColumnsLine input", function(e) {
        manageEditColumnTranslation(this);
    });

    /**
     * This is used to translate "Fix first n columns" where the value of n
     * is the value of a html input.
     */
    function manageEditColumnTranslation(input) {
        var parent = $(input).parent();
        var value = $(input).val();
        var newInput = $(input).clone();
        newInput.attr("value", value);
        var translation = Translator.tr("Fix first {{NUM}} column.", value, { NUM: newInput[0].outerHTML });
        parent.html(translation);
    }

    function saveFixedColumns(input, currentTableReference, successCallback = null){

        var value = input.val();

        if(input.attr("min") > input.val()){
            value = 0;
        }
        if(input.attr("max") < input.val()){
            value = 5;
        }

        var data = {
            TABL10_REFE: currentTableReference,
            TABL11_FIXD: value
        };

        var callback = function(data){
            location.reload();
        }

        if (successCallback !== null) {
            callback = successCallback;
        }
        standardAjaxPost(updateFixedColumnsUrl, data, callback);
    }
    
}

/**
 * SORTABLE COLUMNS DD
 */
export function setupSortableColumnsDropdownChild(ddSelector, currentTableReference, childTableColumns, sortCallback = false){

    if (typeof sortCallback === "undefined" || typeof sortCallback !== "function"){
        sortCallback = function(tableRef){};
    }
        
    var selector = $(ddSelector).find(".columnList .columnGroup[data-table-ref='" + currentTableReference + "']");
    if (selector.length === 0){
        return;
    }

    var colOrder = [];

    if (childTableColumns !== undefined){
        var childTableColumnsJson = JSON.parse(childTableColumns);
        childTableColumnsJson.forEach(function(elm, idx){
            colOrder.push(elm.name);
        });
    }

    selector.sortable({
        axis: "y",
        containment: "parent",        
        items: ".columnSelectLine:not(.not-reorderable)",
        handle: ".dragIcon",                
        cancel: ".not-reorderable",
        update: function(event, ui){

            var newOrder = $(this).sortable('toArray');
            var start = -1;
            var end = -1;

            $.each(colOrder, function(i ,v){
                if(v != newOrder[i] && start == -1){
                    start = i;
                }
                if(v == newOrder[i] && start != -1 && end == -1){
                    end = i - 1;
                }
            });

            if(end == -1){
                end = colOrder.length - 1;
            }

            if(ui.position.top < ui.originalPosition.top){
                var temp = start;
                start = end;
                end = temp;
            }

            colOrder = newOrder;
            
            var childTables = $("table[data-table-ref='" + currentTableReference + "']");
            if (childTables.length > 0){

                childTables.each(function(){
                    var table = $(this).DataTable();
                    table.colReorder.move(start, end, true, true);
                    table.draw();              
                });

            } else {
                sortCallback(currentTableReference, buildColDataFromSortable(selector));
            }            
        }
    });

}

export function buildColDataFromSortable(selector){

    var colData = {};
    selector.find(".columnSelectLine").each(function(idx, elm){

        var line = $(this);
        var colName = line.attr("data-col-name");
        var name = line.find(".columnName .text").text();
        var order = idx;
        var visible = line.find(".checkbox-container input").is(":checked");
        
        var data = {
            name: name,
            order: order,
            visible: visible ? 1 : 0
        };

        colData[colName] = data;

    });              
    
    return colData;
}

export function setupSortableColumnsDropdown(table, ddSelector){


    var colOrder = [];

    $(ddSelector).sortable({
        axis: "y",
        containment: "parent",        
        items: ".columnSelectLine:not(.not-reorderable)",
        handle: ".dragIcon",                
        cancel: ".not-reorderable",
        update: function(event, ui){
            
            var newOrder = $(this).sortable('toArray');
            var start = -1;
            var end = -1;
            $.each(colOrder, function(i ,v){
                if(v != newOrder[i] && start == -1){
                    start = i;
                }
                if(v == newOrder[i] && start != -1 && end == -1){
                    end = i - 1;
                }
            });

            if(end == -1){
                end = colOrder.length - 1;
            }

            if(ui.position.top < ui.originalPosition.top){
                var temp = start;
                start = end;
                end = temp;
            }

            colOrder = newOrder;            
            table.colReorder.move(start, end, true, true);
            table.draw();
        }
    });

    colOrder = $(ddSelector).sortable('toArray');

}


export function setupFixedColumnsEvents(table){

    var $table = $(table.table().node());
    var $tableSection = $table.closest( "#tableSection" );
                
    $tableSection.on({
        mouseenter: function(e){
            var rowId = table.row($(this)).flatten()[0];
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr[data-dt-row='" + rowId + "']", $tableSection).addClass("isHover");
        },
        mouseleave: function(e){
            var rowId = table.row($(this)).flatten()[0];
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr[data-dt-row='" + rowId + "']", $tableSection).removeClass("isHover");
            $(this).removeClass("isHover");
        },
        click: function(e){
            $(".dataTables_wrapper .dataTables_scrollBody table tbody tr", $tableSection).removeClass("isHover");
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr", $tableSection).removeClass("isHover");
            $(this).addClass("isHover");
        }
    }, ".dataTables_wrapper .dataTables_scrollBody table tbody tr");

    $tableSection.on({
        mouseenter: function(e){
            var row = table.row($(this).data("dt-row")).node();
            $(row).addClass("isHover");
        },
        mouseleave: function(e){
            var row = table.row($(this).data("dt-row")).node();
            $(".dataTables_wrapper .dataTables_scrollBody table tbody tr", $tableSection).removeClass("isHover");
            $(".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr", $tableSection).removeClass("isHover");
        },
        click: function(e){
            var row = table.row($(this).data("dt-row")).node();
            $(row).trigger("click");
        }
    }, ".DTFC_LeftWrapper .DTFC_LeftBodyWrapper table tbody tr");

}

/**
 * SHOW FILTERS CONTROLS
 */
export function initShowFilters(tableId, btn, tableReference, defValue = "0", callback = function(shown){}){
    
    btn = $(btn);
    var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
    var sessionStorageKey =`${tableReference}_TABLE_FILTER_STATUS_${storageId}`;
    var showText = Translator.tr("Show Filters");
    var hideText = Translator.tr("Hide Filters");

    var storedValue = defValue;
    if (isSessionStorageAvailable) {
        storedValue = sessionStorage.getItem(sessionStorageKey);
        if (storedValue === null) {
            storedValue = defValue;
        }
    } else {
    }

    if (storedValue == "1") {
        btn.text(hideText);
        btn.attr("data-active", "1");
        searchRow.show();
        if (isSessionStorageAvailable) {
            sessionStorage.setItem(sessionStorageKey, "1");
        }
    } else {
        btn.text(showText);
        btn.attr("data-active", "0");
        searchRow.hide();
        if (isSessionStorageAvailable) {
            sessionStorage.setItem(sessionStorageKey, "0");
        }
    }

    btn.on("click", function(){
        var shown;
        var searchRow = $("#" + tableId + `_wrapper table thead tr.search`);
        if ($(this).attr("data-active") === "1"){
            $(this).text(showText);
            $(this).attr("data-active", "0");
            shown = false;
            searchRow.hide();
            if (isSessionStorageAvailable){
                sessionStorage.setItem(sessionStorageKey, "0");
            }
        } else {
            $(this).text(hideText);
            $(this).attr("data-active", "1");
            shown = true;
            searchRow.show();
            if (isSessionStorageAvailable){
                sessionStorage.setItem(sessionStorageKey, "1");
            }
        }

        callback(shown);
    });
}


export function tableButtonHasClass( $button, className ){
    return $button.hasClass( className ) || $button.parent().hasClass( className )
}

export function getTableButtonData( $button, dataName ){
    var data = $button.data( dataName );
    
    if ( typeof data !== "undefined" ){
        return data;
    }
    
    return $button.parent().data( dataName );
}

/**
 * Table buttons typically have a button element with a span element inside. 
 * When getting a click event the target might be on the span or it might be on the button.
 * This function will return the button element
 */
export function getTableButton( $button ){
    return $button.is( "button" )  ?  $button  :  $button.parent();
}
